import Vuex from 'vuex';
import Vue from 'vue';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

Vue.use(Vuex);

const token = localStorage.getItem('access');
const valid = token != null;

const store = new Vuex.Store({
  state: {
    authorized: valid,
  },
  mutations: {
    // authenticate(state, payload) {
    //   state.authorized = true;
    //   localStorage.access = payload.jwt.access;
    //   localStorage.refresh = payload.jwt.refresh;
    //   localStorage.user = JSON.stringify(payload.jwt.user);
    // },
    authenticate(state, payload) {
      state.authorized = true;
      localStorage.user = JSON.stringify(payload.jwt.user);
    },
    deAuthenticate(state) {
      state.authorized = false;
      localStorage.clear();
      firebase.auth().signOut();
    },
  },
  getters: {
    isAuthenticated(state) {
      if (!state.jwt || state.jwt.split('.').length < 3) {
        return false;
      }
      const data = JSON.parse(atob(state.jwt.split('.')[1]));
      const exp = new Date(data.exp * 1000);
      const now = new Date();
      return now < exp;
    },
  },
});

export default store;
